import { useMemo } from 'react';
import { ConnectedComparableListings } from 'src/components/Listings/ConnectedComparableListings';
import { ConnectedComparableListingsV2 } from 'src/components/Listings/ConnectedComparableListings/ConnectedComparableListingsV2';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  CompListing,
  Feature,
  Listing,
  ListingDetails,
} from 'src/WebApiController';

import { flattenListingGroup } from '../GroupListings/components/groupingUtils';

export const ViewCompsBody = ({
  listing,
  compListings,
  ...rest
}: {
  listing?: ListingDetails | null;
  compListings?: CompListing[] | null;
}) => {
  const hasYourListingsInCompsFeature = useUserHasFeature(
    Feature.YourListingsInComps
  );
  const { eventsTransformed } = useCatalogDataContext();
  const flattenedEventListings = useMemo<Listing[]>(() => {
    return (
      (eventsTransformed
        ?.find((e) => e.event.virtId === listing?.viagVirtId)
        ?.entities?.listings?.flatMap(flattenListingGroup) as Listing[]) ?? []
    );
  }, [eventsTransformed, listing?.viagVirtId]);

  if (hasYourListingsInCompsFeature) {
    return (
      <ConnectedComparableListingsV2
        compListings={compListings ?? []}
        listings={flattenedEventListings}
        selectedListingId={listing?.id}
      />
    );
  }
  return (
    <ConnectedComparableListings
      currentListing={listing ?? undefined}
      comparableListings={compListings ?? []}
      {...rest}
    />
  );
};
